<template>
  <div class="aisea-operation-report-show flex flex-col overflow-x-auto">
    <operation-report-show-body
      ref="operationReportShowBody"
      :style="cssVariables"
      :aoEnterpriseCsvs="aoEnterpriseCsvs"
    />
    <operation-report-show-footer />
  </div>
</template>

<script>
import OperationReportShowBody from "./OperationReportShowBody";
import OperationReportShowFooter from "./OperationReportShowFooter";

import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("operationReport");
import {
  notifySystemError,
  notifyNotFoundError,
  isEditScreen,
} from "@/utils/operations";
import { ColorMixin } from "@/mixins";
const { AISEA_COLOR } = ColorMixin.data();
import operationService from "@/services/operations/operationService";

export default {
  name: "OperationReportShow",

  components: {
    OperationReportShowFooter,
    OperationReportShowBody,
  },

  data() {
    return {
      bodyTop: 84.5234375, // スクロール範囲の決定に使用
      aoEnterpriseCsvs: [], // operations APIから取得したCSV一覧
    };
  },

  computed: {
    cssVariables() {
      return {
        "--body-top": `${this.bodyTop}px`,
        "--footer-height": "100px",
        "--max-body-height":
          "calc(100vh - var(--body-top) - var(--footer-height))",
      };
    },
  },

  methods: {
    ...mapActions(["setOperationReport", "resetState"]),
    async fetchOperationReport() {
      try {
        this.$vs.loading({ color: AISEA_COLOR.BLUE });
        const res = await this.setOperationReport(this.$route.params);
        if (this.isNotFound(res)) {
          notifyNotFoundError(this);
        }
      } catch {
        notifySystemError(this);
      } finally {
        this.$vs.loading.close();
      }
    },
    async fetchOperations() {
      try {
        const res = await operationService.getOperationConfigurations();
        if (res && res.data && Array.isArray(res.data)) {
          // 現在のサービスIDに一致するoperationを探す
          const aoEnterpriseId = this.$route.params.aoEnterpriseId;
          const operation = res.data.find(op => {
            return op.id === aoEnterpriseId;
          });
          if (operation && Array.isArray(operation.ao_enterprise_csvs)) {
            this.aoEnterpriseCsvs = operation.ao_enterprise_csvs;
          }
        }
      } catch (error) {
        console.error("Failed to fetch operations:", error);
      }
    },
    isNotFound(
      res //
    ) {
      return res.code === 404;
    },
    updateCssVariables() {
      const body = this.$refs.operationReportShowBody;
      if (body) {
        this.bodyTop = body.$el.getBoundingClientRect().top;
      }
    },
  },

  async created() {
    await this.fetchOperationReport(); // 初期表示に最新データを取得する
    await this.fetchOperations(); // ダウンロード可能csvデータを取得する
  },
  async beforeRouteEnter(_, from, next) {
    const fromEditScreen = isEditScreen(from);
    next(async vm => {
      if (fromEditScreen) {
        await vm.fetchOperationReport(); // 編集から詳細モードに入った後、最新データを取得する
      }
    });
  },

  async mounted() {
    await this.$nextTick();
    this.updateCssVariables();
  },

  async beforeRouteLeave(to, _from, next) {
    const toEditScreen = isEditScreen(to);

    if (toEditScreen) {
      // 編集モードに入る前に最新データを取得する
      await this.fetchOperationReport();
    }
    next();
  },

  beforeDestroy() {
    this.resetState(); // レポートのデータを削除
  },
};
</script>
<style lang="scss">
.router-view {
  &:has(.aisea-operation-report-show) {
    height: calc(var(--vh, 1vh) * 100); // ページの高さを整える
  }
}
</style>
